import EcoFaqWithImg, { EcoFaqWithImgProps } from 'eco-design/sections/eco-faq-win-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const K: React.FC = () => {
    const { t } = useLang('d3u');
    const props: EcoFaqWithImgProps = {
        theme: 'white',
        items: [
            {
                title: t('K_item1_name'),
                desc: t('K_item1_text'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760925836538/11_1.jpg',
            },
            {
                title: t('K_item2_name'),
                desc: t('K_item2_text'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760925837769/11_2.jpg',
            },
            {
                title: t('K_item3_name'),
                desc: t('K_item3_text'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760925992747/11_3.jpg',
            },
            {
                title: t('K_item4_name'),
                desc: t('K_item4_text'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760925842060/11_4.jpg',
            },
            {
                title: t('K_item5_name'),
                desc: t('K_item5_text'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1760926082357/11_5.jpg',
            },
        ],
    };

    return (
        <section className={`${css.section} D3U-K GtmModuleData-section`} id="D3U-K" data-section-id={'D3U-K'} data-section-id2={t('K_title')}>
            <div className="info">
                <p className="label">{t('K_label')}</p>
                <p className="title">{t('K_title')}</p>
            </div>
            <EcoFaqWithImg {...props} />
        </section>
    );
};

export default K;
